module.exports = __webpack_public_path__ + "img/oblaka.3bafe3cc.png";